// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ucUBGzS8PqeM5I {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 600px;
}
.ucUBGzS8PqeM5I > button {
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
}
.ucUBGzS8PqeM5I div {
  display: block;
  height: 100%;
  text-align: center;
}
.ucUBGzS8PqeM5I div h4 {
  margin: 20px 16px 24px;
  font-size: 20px;
}
.ucUBGzS8PqeM5I div p {
  margin: 0 0 16px;
  font-size: 16px;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"errorMessage": `ucUBGzS8PqeM5I`
};
export default ___CSS_LOADER_EXPORT___;
